<template>
  <!--弹框Terms and use 开始-->
  <el-dialog :visible.sync="framePointsDetailsDia" width="75%" :show-close="termsAndConditionsShowClose" class="tax-margin" :modal-append-to-body="false" :append-to-body="true">
    <div class="container">
      <div class="points-title">Points Detail</div>
      <!-- 表格区域 -->
      <div class="table-container">
        <table class="points-table">
          <thead>
            <tr>
              <th width="280"><el-date-picker
                v-model="dateRange"
                type="daterange"
                range-separator="—"
                start-placeholder="Start date"
                end-placeholder="End date"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                style="width: 280px"
                @change="getPointsList"
                >
              </el-date-picker>
            </th>
            <th width="195"><span>Type</span>
              <el-select v-model="selectedType" placeholder="Type" style="width: 140px"  @change="getPointsList">
                <el-option label="Points" value="2"></el-option>
                <el-option label="Pending points" value="1"></el-option>
              </el-select>
            </th>
            <th width="237">
              <span>Operation Type</span>
              <el-select v-model="selectedOperation" placeholder="Operation Type" style="width: 95px"  @change="getPointsList">
                <el-option label="All" value="0"></el-option>
                <el-option label="Add" value="1"></el-option>
                <el-option label="Deduct" value="2"></el-option>
              </el-select>
            </th>
            <th width="150">Order No</th>
            <th width="120">Points</th>
            <th width="200">Reason</th>
          </tr>
        </thead>
        <tbody>
            <tr v-for="(item, index) in pointsData" :key="index">
              <td>{{item.date}}</td>
              <td>{{item.pointsType}}</td>
              <td>
                <span :class="[item.pointsSign === '+' ? 'points-add' : 'points-deduct']">
                  {{item.pointsSign === '+' ? 'Add' : 'Deduct'}}
                </span>
              </td>
              <td>{{item.orderno}}</td>
              <td>
                <span :class="[item.pointsSign === '+' ? 'points-add' : 'points-deduct']">
                  {{item.pointsSign === '+' ? '' : '-'}}{{item.pointsAmount}}
                </span>
              </td>
              <td>{{item.event}}</td>
            </tr>
          </tbody>
        </table>
        <div class="pagination-container">
          <el-pagination
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="pageSize"
          :total="totalNum"
          :page-count="pageCount"
          layout="prev, pager, next"
          background>
        </el-pagination>
      </div>
    </div>
    </div>
  </el-dialog>
  <!--弹框1 结束-->
  <!--引入方式-->
  <!-- <framePointsDetails :framePointsDetailsDialog.sync="framePointsDetailsDialog"></framePointsDetails> -->
</template>

<script>
import { getPointsList } from '@/request/user.js'
export default {
  name: 'framePointsDetails',
  props: {
    framePointsDetailsDialog: {
      type: Boolean,
      default: false
    }
  },
  data () {
    // 获取当前季度的起止时间
    const now = new Date()
    const currentQuarter = Math.floor(now.getMonth() / 3)
    const startQuarter = new Date(now.getFullYear(), currentQuarter * 3, 1)
    const endQuarter = new Date(now.getFullYear(), (currentQuarter + 1) * 3, 0)

    // 本地时间格式化函数
    const formatLocalDate = (date) => {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    }
    return {
      frameWidth: '450px',
      showClo: false,
      termsAndConditionsShowClose: true,
      dateRange: [
        formatLocalDate(startQuarter),
        formatLocalDate(endQuarter)
      ],
      selectedType: '2',
      selectedOperation: '0',
      pointsData: [],
      pageSize: 20, // 每页显示条数
      currentPage: 1, // 当前页码
      totalNum: 0, // 总记录数
      pageCount: 0 // 总页数
    }
  },
  methods: {
    handleCurrentChange (val) {
      this.currentPage = val
      this.getPointsList()
    },
    async getPointsList () {
      try {
        var requestTime = parseInt(new Date().getTime())
        // 验证verify
        var token = this.$md5('0' + this.common.lfSignKey)
        if (localStorage.getItem('token')) {
          token = localStorage.getItem('token')
        }

        // 处理日期范围
        let startDate = ''
        let endDate = ''
        if (this.dateRange && this.dateRange.length === 2) {
          [startDate, endDate] = this.dateRange
        }

        var time = parseInt(new Date().getTime() / 1000)

        const params = {
          token: token,
          operation: 'getPointsList',
          source: this.common.sourceSet(),
          pointsType: this.selectedType,
          pointsAction: this.selectedOperation,
          page: this.currentPage,
          startDate: startDate,
          endDate: endDate,
          time: time
        }
        var paramsData = this.common.encryptionData(params, this)
        getPointsList(paramsData).then(res => {
          if (res.flag === '200') {
            this.currentPage = res.data.currentPage
            this.totalNum = res.data.totalNum
            this.pageCount = res.data.pageCount
            this.pointsData = res.data.data
          }
        }).then(res => {
          var responseTime = parseInt(new Date().getTime())
          this.$nextTick(() => {
            this.loadPageView(paramsData, res, requestTime, responseTime, 'getPointsList')
          })
        })
      } catch (error) {
        console.error('get points list error:', error)
      }
    }
  },
  computed: {
    framePointsDetailsDia: {
      get () {
        return this.framePointsDetailsDialog
      },
      set (val) {
        this.$emit('update:framePointsDetailsDialog', val)
      }
    }
  },
  mounted () {
    // this.getPointsList();
    if (document.body.clientWidth < 1001) {
      this.frameWidth = '95%'
    } else {
      this.frameWidth = '450px'
    }
  }
}
</script>

<style scoped>
/*控制弹窗高度*/
/deep/ .el-dialog {
  margin-top: 15vh !important;
  min-height: 30vh !important; /* 添加最大高度限制 */
  max-height: 85vh !important; /* 添加最大高度限制 */
}

/deep/ .el-dialog__body {
  max-height: 70vh !important; /* 使用固定的最大高度 */
  height: auto !important; /* 允许自动高度，但不超过最大高度 */
  overflow-y: auto !important; /* 允许内容自然展开 */
  padding: 0px 10px 30px;
}

/*内容样式*/
body {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  line-height: 1.6;
  margin: 0;
  padding: 0;
  color: #333333;
  background-color: #f5f7fa;
}

.container {
  padding: 0px 20px;
}

.points-title {
  font-size: 18px;
  font-weight: 500;
  color: #1D2129;
  margin-bottom: 20px;
}

.search-area {
  display: flex;
  gap: 15px;
  margin-bottom: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid #E5E6EB;
}

.table-container {
  margin-top: 20px;
  height: calc(100% - 80px); /* 减去标题和其他元素的高度 */
  overflow-y: auto; /* 添加垂直滚动条 */
  scrollbar-width: thin; /* Firefox */
  scrollbar-color: #C0C4CC #F5F7FA; /* Firefox */
}

/* 为 WebKit 浏览器定制滚动条 */
.table-container::-webkit-scrollbar {
  height: 8px;
  background-color: #F5F7FA;
}

.table-container::-webkit-scrollbar-thumb {
  background-color: #C0C4CC;
  border-radius: 4px;
}

.table-container::-webkit-scrollbar-thumb:hover {
  background-color: #909399;
}

.operation-type {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;
}

.operation-add {
  background-color: #E8F3E8;
  color: #2F7000;
}

.operation-deduct {
  background-color: #FFE8E8;
  color: #FF3B30;
}

.points-value {
  font-weight: 500;
}

.points-add {
  color: #2F7000;
}

.points-deduct {
  color: #E80000;
}

.points-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
  white-space: nowrap; /* 防止单元格内容换行 */
  margin-bottom: 20px;
}

.points-table th {
  background-color: #F8F9FA;
  color: #1D2129;
  font-weight: 500;
  padding: 12px;
  text-align: center; /* 添加水平居中 */
  vertical-align: middle; /* 添加垂直居中 */
  border-bottom: 1px solid #E5E6EB;
}

.points-table td {
  padding: 12px;
  text-align: center; /* 添加水平居中 */
  vertical-align: middle; /* 添加垂直居中 */
  border-bottom: 1px solid #E5E6EB;
}

/* 分页样式 */
.pagination-container {
  margin-top: 20px;
  text-align: center;
  padding: 0 20px 20px;
}

/deep/ .el-pagination {
  padding: 0;
  margin: 0;
}

/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #5366A3;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/public/framePointsDetails.vue